var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("AFFILIATED MEDICAL CLINIC")]),_c('h4',[_vm._v(" A duly licensed medical health care facility included in the list of affiliated medical clinics of HMI which has an existing and valid affiliation agreement with HMI and where a Member can avail of medical services pursuant to this Agreement. ")])])
}]

export { render, staticRenderFns }